import { Component, OnInit } from '@angular/core';
import { BpgEventsService } from '../../bpg-events/bpg-events.service';
import { Budget, Hoshin, BudgetHoshin } from "../../bpg-common/services/data.services";
import { HoshinBudgetService } from "../hoshin-budget.service";
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { DataService } from "../../bpg-common/services/data.services";
import { DatePipe } from '@angular/common';

import { setFullYear } from 'ngx-bootstrap/chronos/utils/date-setters';
import { DATE } from 'ngx-bootstrap/chronos/units/constants';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';
import { SelfService } from '../../bpg-self-services/self-services.service.ts';
import { LandingPaginationDTO } from "../../bpg-common/services/data.services";
import * as cloneDeep from 'lodash/cloneDeep';



@Component({
  selector: 'app-create-and-edit-hoshin',
  templateUrl: './create-and-edit-hoshin.component.html',
  styleUrls: ['./create-and-edit-hoshin.component.css']
})
export class CreateAndEditHoshinComponent implements OnInit {

  budgets = [];
  initialBudgetName: any;
  id: string = "0";
  loginData = JSON.parse(localStorage.getItem('loginData'));
  userAndRoleIdDTO = {
    userId: this.loginData['userId'],
    roleId: localStorage.getItem('adminId')
  }
  chapterDropDownList: any;
  fileName: string = "Upload document";
  budget: Budget;
  hoshins: Hoshin[];
  budgetHoshin: BudgetHoshin = new BudgetHoshin();
  msg1: string;
  msg2: string;
  method: string;
  param: string;
  budgetTypes: any;
  businessDrivers: any;
  RegMinDate: any;
  fileExtension: any;
  fileExtensionError: boolean = false;
  fileSize: number;
  fileSizeExtensionError: boolean = false;
  selectedFile: File = null;
  alertSuccess: boolean;
  fileList: File[] = [];
  budgetData: any = null;
  hoshinList: any = null;
  hoshinIdsToDelete: Array<number> = new Array<number>();
  currentDate: any;
  maxDate: any;
  minDate: any;
  datevalue: any;
  selectedMonthYear: any;
  date: any;
  errorMsg: string;
  alertFailure: boolean = false;
  alertError: boolean = false;
  alertSuccessOnSave: boolean;
  buttonType: any;
  adminId: any;
  loginDetails: any;
  extractedYear: any;
  isHoshinExist: boolean = false;
  thisYear: any;
  alertErrorFiscal: boolean = false
  ErrorFiscal: boolean = false;
  year: any;
  alertErrorFiscalMsg: boolean = false;
  timeOutError: boolean;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  status: any;
  frequency: any;
  LandingPaginationDTO: LandingPaginationDTO = new LandingPaginationDTO();
  userList: any
  lead_1: any;
  lead_2: any;

  userId: any;
  editChapterId: any;
  evaluationList: any;
  isbpgAdmin: boolean = false;
  isbpgLeadAdmin = false;
  isNaacAdmin: boolean = false;
  rejectFlag : boolean = false;
 hoshinIdFlag : boolean = false;
  hoshinCloneResponse: any = [];
  enableForm:boolean=true;

  removeToolbar: any = { disableNativeSpellChecker: false, toolbar: 'Basic', uiColor: '#FFFFFF', basicEntities: false, fillEmptyBlocks: false, removeButtons: 'Source,Save,NewPage,Preview,Print,Templates,Pasteas plain text,PastefromWord,Find,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,SelectionField,Button,ImageButton,HiddenField,Italic,Decrease,Increase,Block,Create Div Container,Text direction from left to right,Text direction from right to left,Set language,Link,Unlink,Image,Flash,Table,Horizontal,Smiley,Insert Special Character,Insert Page Break for Printing,IFrame,Formatting,Paragraph,Font,FontSize,TextColor,Maximize,ShowBlocks,About,forceSpellChecker,Cut,Copy,Paste,Undo,Redo,Anchor,Underline,Strike,Subscript,Superscript,Bold,RemoveFormat', height: '90px', Backgroundcolor: 'black !important' };
  //height:any ={};

  /**
* @class BpgCreateAndEditEventComponent
* @constructor
*/
  constructor(private bpgEventService: BpgEventsService,
    private hoshinBudgetService: HoshinBudgetService,
    private router: Router,
    private spinner: Ng4LoadingSpinnerService,
    private data: DataService,
    private datepipe: DatePipe,
    
    private environment: EnvironmentConfiguration,
    private userService: SelfService,
  ) { }

  ngOnInit() {

    if (this.environment.envName == 'dev' || this.environment.envName == 'qa' || this.environment.envName == 'prod') {
              if (localStorage.getItem('loginData')== null || localStorage.getItem('loginData')== undefined) {

        this.router.navigate(['/log-out']);
      }
    }

    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 500);

    this.loginDetails = JSON.parse(localStorage.getItem("loginData"));
    if(localStorage.getItem('isbpgAdmin') == 'true')
    {
      this.isbpgAdmin = true
}
   if(localStorage.getItem('isbpgLeadAdmin')==='true'){
     this.isbpgLeadAdmin = true;
   }
   if(localStorage.getItem('isNaacAdmin') == 'true')
   {
     this.isNaacAdmin = true
   }
    this.adminId = localStorage.getItem('adminId');
    if (this.adminId !== "1" && this.adminId !== "2" && this.adminId !== "3" && !this.isbpgAdmin && !this.isbpgLeadAdmin) {
      this.router.navigate(['/site-home']);
    }
    // if (this.loginDetails == null) {
    //   this.router.navigate(['/login']);
    // }
    sessionStorage.removeItem("saveBudget");

    this.currentDate = new Date();
    var month = this.currentDate.getMonth();

    if (month + 1 < 4) {
      var fisyear = this.currentDate.getFullYear();
    }
    else {
      var fisyear = this.currentDate.setFullYear((this.currentDate.getFullYear() + 1));
    }
    var year = this.currentDate.getFullYear();
    var month = this.currentDate.getMonth();


    // if (month + 1 < 4) {
      this.minDate = new Date(year - 1 + "/04/01");
      this.maxDate = new Date(year + "/03/30");
    // }
    // else {
      ///  var currentMonth = month + 1;
      // this.minDate = new Date(year-1+"/"+currentMonth+"/01");
    //   this.minDate = new Date(year - 1 + "/04/01");
    //   this.maxDate = new Date(year + "/03/30");
    // }

    this.businessDrivers = [{ type: "Market Place Connection" }, { type: "Work Force Inclusion" },
    { type: "Work Place Engagement" }]

    this.status = [{ type: "Open" }, { type: "Completed" },
    { type: "Cancelled" }, { type: "Postponed" }]

    this.budgetTypes = [{ type: 'Event' }, { type: 'Food' }, { type: 'Other' }]

    this.frequency = [{ type: 'One-Time' }, { type: 'Monthly' }, { type: 'Quarterly' }, { type: 'Bi-Monthly' }, { type: 'Semi-Annually' }]

    this.evaluationList = [{ name: 'None', value: null }, { name: '\u26AA  Achieved', value: '\u26AA  Achieved' }, { name: '\u25B3	 Partially Met', value: '\u25B3	 Partially Met' }, { name: '\u2A09  Incomplete/Under Achieved', value: '\u2A09  Incomplete/Under Achieved' }];

    this.bpgEventService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(data => {
      this.chapterDropDownList = data;
      this.chapterDropDownList.map((i) => { i.siteName = i.siteName + '-' + i.bpgName; return i; })
    }, err => {
      this.spinner.hide();
      console.log(JSON.stringify(err));
      if (err.value.statusText !== undefined && err.value.statusText == ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });

    //this.data.budgetData.subscribe(data => this.budgetData = data);
    this.budgetData = JSON.parse(sessionStorage.getItem('editBudget'))
    if (this.budgetData != null) {
      if (this.budgetData.clone === true) {
        this.budget = this.budgetData;
        let budgetId = this.budgetData.budgetId;
        this.hoshinBudgetService.getCloneHoshins(budgetId).subscribe(data => {
          this.hoshinCloneResponse = data;
          this.hoshins = this.hoshinCloneResponse.hoshinMasterDTOList;
          this.budget = this.hoshinCloneResponse.budgetMasterDTO;
          this.hoshinIdsToDelete = this.hoshinCloneResponse.deleteHoshinIds;
          this.budget.budgetAllocatedDate = new Date();
          this.budget.budgetRequestedBy = this.loginData['userId'];
          this.budget.budgetRequestedDate = new Date();
          this.onChapterSelection(this.hoshinCloneResponse.budgetMasterDTO.chapterId)
       
         
        }, err => {
          this.spinner.hide();
          console.log(JSON.stringify(err.value.message));
          if (err.value.statusText == ConstantValues.unknownError) {
            this.timeOutError = true;
          }
        });
      } else {
        this.budget = this.budgetData;
       
        this.editChapterId = this.budgetData.chapterId
        if (this.budget.fiscalYear != null) {
          var year1 = parseInt(this.budget.fiscalYear);
          this.minDate = new Date(year1 - 1 + "/04/01");
          this.maxDate = new Date(year1 + "/03/30");
        }
        this.hoshinBudgetService.getHoshins(this.budgetData.budgetId).subscribe(data => {
          this.hoshins = data;
          this.findTotalBudgetAmount();
          this.onChapterSelection(this.budget.chapterId);

        }, err => {
          this.spinner.hide();
          console.log(JSON.stringify(err.value.message));
          if (err.value.statusText == ConstantValues.unknownError) {
            this.timeOutError = true;
          }
        });
      }
    } else {
      this.hoshins = [{
        hoshinId: null,
        chapterId: 1,
        name: 'BPG Initiative',
        bpgInitiative: '',
        businessDrivers: null,
        status: null,
        actionPlan: '',
        kpi: '',
        estimatedTiming: '',
        midYearResults: '',
        yearEndResults: '',
        budgetType: null,
        proposedBudget: null,
        challenges: '',
        supportingDoc1: 'Upload Document',
        fiscalYear: year,
        frequency: null,
        leadId1: null,
        leadId2: null,
        additionalFunding: null,
        additionalFundingSource: null,
        evaluation: null
      }];


      this.budget = {
        chapterId: null,
        fiscalYear: year,
        affinityGoals: '',
        chapterGoals: '',
        budgetAllocatedBy: null,
        budgetAllocatedDate: new Date(),
        budgetSource: "BPG",
        budgetRequestedBy: this.loginData['userId'],
        budgetRequestedDate: new Date()
      }
      this.budget.requestedBudgetAmount = 0;
    }
  }

  /** add hoshin
* @class CreateAndEditHoshinComponent
* @method addHoshin
*/
  addHoshin() {
    var year = this.currentDate.getFullYear();
    this.id = this.id + 1;
    //  this.hoshins = JSON.parse(JSON.stringify(this.hoshins))
    //to prevent the copying of values from old array
    this.hoshins = cloneDeep(this.hoshins);

    this.hoshins.push({
      hoshinId: null,
      chapterId: 1,
      name: 'BPG Initiative',
      bpgInitiative: '',
      status: null,
      businessDrivers: null,
      actionPlan: '',
      kpi: '',
      estimatedTiming: '',
      midYearResults: '',
      yearEndResults: '',
      budgetType: null,
      proposedBudget: null,
      challenges: '',
      supportingDoc1: 'Upload Document',
      fiscalYear: year,
      frequency: null,
      leadId1: null,
      leadId2: null,
      additionalFunding: null,
      additionalFundingSource: null,
      evaluation: null
    });

  }
  /**delete hoshin on click of delete button
* @class CreateAndEditHoshinComponent
* @method removeHoshin
*/
removeHoshin(index, hoshin, form) {
  this.spinner.show();
  console.log(form)
    if (hoshin.hoshinId != null) {
      this.hoshinIdsToDelete.push(hoshin.hoshinId);
    }
    var index1 = this.hoshins.indexOf(hoshin);
    if (index1 !== -1) {
      this.enableForm=false;
      // form.resetForm();
      let temp;
      console.log(this.hoshins)

      this.hoshins.splice(index1, 1);
       console.log(temp);

      console.log(this.hoshins)
      setTimeout(() => {this.enableForm=true;})
      setTimeout(() => {this.spinner.hide()},500)
      const element = document.getElementById("box");
      element.scrollIntoView(false);
      // element.scrollIntoView({ block: "end" });
      // element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
      // this.hoshins = [...this.hoshins];
      // this.hoshins = this.hoshins.filter(
      //   (hoshin,index) => index1 != index
      // )
    }

    this.budget.requestedBudgetAmount = this.budget.requestedBudgetAmount - hoshin.proposedBudget;
  }


  /** To set filename
* @class CreateAndEditHoshinComponent
* @method onFileSelected
*/

  public onFileSelected(event, index) {
    this.fileExtensionError = false;
    this.fileSizeExtensionError = false;
    if (event.target.files.length > 0) {
      this.fileName = event.target.files[0].name;
      this.fileSize = event.target.files[0].size;
      var allowedExtensions = ["xls", "xlsx", "doc", "docx", "txt", "pdf"];
      this.fileExtension = this.fileName.split('.').pop();

      if (this.isInArray(allowedExtensions, this.fileExtension)) {

        if (this.fileSize > 5242880) {
          this.fileSizeExtensionError = true;
        } else {
          this.fileExtensionError = false;
          this.fileSizeExtensionError = false;
          this.selectedFile = <File>event.target.files[0];
          this.hoshins[index].supportingDoc1 = this.selectedFile.name;
        }
      } else {
        this.fileExtensionError = true;
      }
    }
  }

  /** checks if word exists in array
   * @class CreateAndEditHoshinComponent
   * @method isInArray
   */
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  /** For saving budget
  * @class CreateAndEditHoshinComponent
  * @method saveBudget
  */
  public saveBudget(action) {
    this.errorMsg = "";
    this.timeOutError = false;
    var returnVal = this.fiscalYearValidation(this.budget.fiscalYear);
    if (returnVal == true) {
      setTimeout(() => {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      }, 400);
      return;
    }

    if (action == 'save') {
      let status = JSON.parse(sessionStorage.getItem('editBudget'));
      if (this.budget.budgetStatus == undefined || this.budget.budgetStatus == null || this.budget.budgetStatus == 'NEW') {
        this.budget.budgetStatus = 'NEW';
      } else {
        console.log('Status ::', this.budget.budgetStatus);
        this.budget.budgetStatus = status.budgetStatus;
      }
      this.budgetHoshin.hoshinSave = true;
    } else if (action == 'submit') {
      this.budget.budgetStatus = 'SUBMITTED';
      this.budgetHoshin.hoshinSave = false; 
      for(var i = 0 ; i< this.hoshins.length ; i++)     {
        
       if(this.hoshins[i].isSuperAdminApproved == false || this.hoshins[i].isSuperAdminApproved == null)
        this.rejectFlag = true;
       
    }
    for(var i = 0 ; i< this.hoshins.length ; i++)     {
   
      if(this.hoshins[i].hoshinId==null)
       this.hoshinIdFlag = true;
   }
    
     if(this.rejectFlag == false)
     this.budget.budgetStatus = 'APPROVED';
     if(this.hoshinIdFlag == true)
     this.budget.budgetStatus = 'SUBMITTED';

     if( this.budget.budgetStatus == 'APPROVED')
     {
       for (var i = 0; i< this.hoshins.length ; i++)
       {
         
         if(this.hoshins[i].superAdminApprovedBudget!=null){
       this.budget.approvedBudgetAmount =   this.budget.approvedBudgetAmount + this.hoshins[i].superAdminApprovedBudget
         }
       }
     }
  }
    for (var i = 0; i < this.hoshins.length; i++) {
      this.hoshins[i].fiscalYear = this.budget.fiscalYear;
      if (this.hoshins[i].frequency == 'monthly' || this.hoshins[i].frequency == 'quarterly') {
        this.hoshins[i].estimatedTiming = '';
      }
      if (this.hoshins[i].actionPlan.length > 499) {
        this.errorMsg = 'Action plan should be less than 500 characters'
        this.alertFailure = true;
        return
      } else if (this.hoshins[i].kpi.length > 499) {
        this.errorMsg = 'KPI should be less than 500 characters'
        this.alertFailure = true;
        return
      } else if (this.hoshins[i].challenges.length > 499) {
        this.errorMsg = 'Challenges should be less than 500 characters'
        this.alertFailure = true;
        return
      } else if (this.hoshins[i].midYearResults.length > 499) {
        this.errorMsg = 'Mid year results should be less than 500 characters'
        this.alertFailure = true;
        return
      } else if (this.hoshins[i].yearEndResults.length > 499) {
        this.errorMsg = 'Year end results should be less than 500 characters'
        this.alertFailure = true;
        return
      }

    }
    this.budgetHoshin.deleteHoshinIds = this.hoshinIdsToDelete;

    var estimatedTiming1 = this.hoshins[0].estimatedTiming;
    // if(estimatedTiming1 == ''){
    //   this.errorMsg = "Please enter estimated timing";
    //   this.alertFailure = true;
    //   setTimeout(function () {
    //   this.alertFailure = false;
    //   }.bind(this), 10000);
    //   return;
    // }
if(estimatedTiming1== null)
{
    // this.extractedYear = parseInt(estimatedTiming1.substr(estimatedTiming1.length - 4)) + 1;
    // if (this.budget.fiscalYear != this.extractedYear && this.budget.fiscalYear > this.extractedYear && this.isHoshinExist == true) {

      this.errorMsg = "Please update estimated timing";
      this.isHoshinExist = false;
      this.alertFailure = true;
      setTimeout(function () {
        this.alertFailure = false;
      }.bind(this), 10000);
      return;
    //}
  }


  if(estimatedTiming1!=null)
  {
      this.extractedYear = parseInt(estimatedTiming1.substr(estimatedTiming1.length - 4)) + 1;
    if (this.budget.fiscalYear != this.extractedYear && this.budget.fiscalYear > this.extractedYear && this.isHoshinExist == true) {

      this.errorMsg = "Please update estimated timing";
      this.isHoshinExist = false;
      this.alertFailure = true;
      setTimeout(function () {
        this.alertFailure = false;
      }.bind(this), 10000);
      return;
    }
  }
    this.spinner.show();
    this.budgetHoshin.budgetMasterDTO = this.budget;
    this.budgetHoshin.hoshinMasterDTOList = this.hoshins;
    //this.budgetHoshin.deleteHoshinIds = [];


    this.hoshinBudgetService.saveBudget(this.budgetHoshin).subscribe(data => {
      this.spinner.hide();
      if (data != null && data.body.message == undefined) {
        // window.scrollTo(0, 0);

        if (action == 'save') {
          this.alertSuccessOnSave = true;
          this.alertSuccess = false;
        } else if (action == 'submit') {
          this.alertSuccess = true;
          this.alertSuccessOnSave = false;
        }
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);

      }
      else if (data.body.message != undefined) {
        this.errorMsg = data.body.message.split(":")[0];
        this.alertFailure = true;
        this.isHoshinExist = true;

        setTimeout(function () {
          this.alertFailure = false;
        }.bind(this), 500000);
        return
      }
      this.budget = data.body.budgetMasterDTO;
      this.hoshins = data.body.hoshinMasterDTOList;
      // setTimeout(() => {
      //   this.router.navigate(['/hoshin-listing']);
      // }, 6000);

      if (this.selectedFile != null) {
        this.fileList.push(this.selectedFile);
        this.bpgEventService.uploadFile(this.fileList, 'BUDGET', data.budgetId).subscribe(data => {
        }, err => {
          this.spinner.hide();
          console.log(JSON.stringify(err.value.message));
          if (err.value.statusText == ConstantValues.unknownError) {
            this.timeOutError = true;
          }
        });
      }
    }, err => {
      this.spinner.hide();
      console.log(JSON.stringify(err.value.message));
      if (err.value.statusText == ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });

  }



  /** to select cancel
 * @class CreateAndEditHoshinComponent
 * @method cancelClick
 */
  cancelClick() {
    this.method = "navigate";
    this.msg1 = " Are you sure you want to leave this page ? Changes you made may not be saved.";
    this.param = "";
  }

  /** to select confirm
   * @class CreateAndEditHoshinComponent
   * @method submitClick
   */
  saveClick() {
    this.method = "saveBudget";
    this.msg1 = " Do you want to save this hoshin ?";
    this.param = "save";
  }

  /** to select confirm
    * @class CreateAndEditHoshinComponent
    * @method submitClick
    */
  submitClick() {
    this.method = "saveBudget";
    this.msg1 = " Do you want to submit this hoshin ?";
    this.param = "submit";
  }

  /** to navigate to previous page
* @class CreateAndEditHoshinComponent
* @method navigate
*/
  navigate() {
    sessionStorage.setItem(this.buttonType, "CANCEL");
    this.router.navigate(['hoshin-listing']);
    window.scrollTo(0, 0);
  }

  /** month year selection
* @class CreateAndEditHoshinComponent
* @method onOpenCalendar
*/
  onOpenCalendar(container) {
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };
    container.setViewMode('month');
  }

  /** month year selection
* @class CreateAndEditHoshinComponent
* @method findTotalBudgetAmount
*/
  findTotalBudgetAmount() {
    var total = 0;
    for (var i = 0; i < this.hoshins.length; i++) {
      if (this.hoshins[i].proposedBudget) {
        var parsedBudget: number;
        parsedBudget = Number(this.hoshins[i].proposedBudget);
        total = total + parsedBudget;
        this.budget.requestedBudgetAmount = total;
      }
    }
  }

  /** on date change
* @class CreateAndEditHoshinComponent
* @method onDateChange
*/
  onDateChange(event, i) {
    this.selectedMonthYear = event;
    this.date = new Date(this.selectedMonthYear);
    var transformdate = this.datepipe.transform(this.date, 'MMMM yyyy');
    this.hoshins[i].estimatedTiming = transformdate.toString();
  }
  /** on fiscal year change
* @class CreateAndEditHoshinComponent
* @method setEstimatedTimeBasedOnFiscalYear
*/
  setEstimatedTimeBasedOnFiscalYear() {
    var year = parseInt(this.budget.fiscalYear);
    this.minDate = new Date(year - 1 + "/04/01");
    this.maxDate = new Date(year + "/03/30");
    for (var i = 0; i < this.hoshins.length; i++) {
      this.hoshins[i].estimatedTiming = '';
    }
  }

  fiscalYearValidation(fisYear) {
    this.thisYear = new Date();
    var yearNow = this.thisYear.getFullYear();
    var month = this.currentDate.getMonth();
    if (month + 1 >= 4) {
      if (fisYear <= yearNow) {
        this.alertErrorFiscal = true;
        return true;
      }
      else {
        this.alertErrorFiscal = false;
      }
    }
    else if (month + 1 < 4) {
      if (fisYear < yearNow) {
        this.alertErrorFiscalMsg = true;
        return true;
      }
      else {
        this.alertErrorFiscalMsg = false;
      }
    }
  }

  onChapterSelection(chapterId) {
    if (this.budgetData == null) {
      for (var i = 0; i < this.hoshins.length; i++) {
        this.hoshins[i].leadId1 = null;
        this.hoshins[i].leadId2 = null;
        this.userId = null;
      }
    }
    else if (this.editChapterId != chapterId && this.budgetData.clone != true) {
      for (var i = 0; i < this.hoshins.length; i++) {
        this.hoshins[i].leadId1 = null;
        this.hoshins[i].leadId2 = null;
        this.userId = null;
      }
    }

    let landingDto = {
      "filter": {
        "chapterId": chapterId
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "",
      "uid": ""
    }
    this.userService.getUserDropDown(landingDto).subscribe(data => {
      this.userList = data;
      this.userList.map((i) => {
        i.userFirstName = i.userFirstName + ' ' + i.userLastName;
        return i;
      })

    }, err => {
      console.log(JSON.stringify(err.value.message));
      if (err.value.statusText == ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });

  }


}
